<ng-container *finLet="twoFactorAuthService.enabledStatus$ | async as twoFactorAuthEnabledStatus">
  <p
    [innerHTML]="
      'plus.profile.twoFactorAuth.email.verificationStep.description'
        | finLocalization: { email: newEmail || (profile$ | async)?.email }
    "
    class="mr-small-b"
  ></p>

  <form (ngSubmit)="verifyCode()" [formGroup]="verificationForm" class="form-container service-form grow">
    <div class="flex form-subgroup" [class.verification-code-input]="inModalLayout">
      <ng-container *ngIf="inModalLayout; else normalInput">
        <fcom-text-input
          [id]="'email-verification-code'"
          [parentForm]="verificationForm"
          [controlName]="'verificationCode'"
          [translationPrefix]="'plus.profile.twoFactorAuth.email.verificationStep.fields'"
          [placeHolder]="'plus.profile.twoFactorAuth.email.verificationStep.fields.placeholder'"
          [displayMargin]="false"
          [required]="false"
          data-testid="fin-loyalty-email-change-verification-mfa-form-modalinput"
        />
      </ng-container>
      <ng-template #normalInput>
        <fin-form-input-text
          [id]="'email-verification-code'"
          [parentForm]="verificationForm"
          [controlName]="'verificationCode'"
          [translationPrefix]="'plus.profile.twoFactorAuth.email.verificationStep.fields'"
          [displayMargin]="false"
          [required]="false"
          data-testid="fin-loyalty-email-change-verification-mfa-form-normalinput"
        />
      </ng-template>

      <div class="full-width ms-small-l" *ngIf="!inModalLayout">
        <fcom-button
          [type]="ButtonType.SUBMIT"
          [text]="'actions.verify' | finLocalization"
          [loading]="twoFactorAuthEnabledStatus.isLoading"
          [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          data-testid="loyalty-email-change-verification-mfa-form-submit-button"
        />
      </div>
    </div>
  </form>

  <p class="ms-small-t">
    {{ 'plus.profile.twoFactorAuth.email.verificationStep.noCodeReceived' | finLocalization }}
    <fcom-link
      (afterNavigation)="send2faEmailVerificationCode()"
      data-testid="loyalty-email-change-verification-mfa-form-resend-link"
    >
      {{ 'actions.resend' | finLocalization }}
    </fcom-link>
  </p>

  <fcom-notification
    *ngIf="showSend2faEmailVerificationCodeSuccessNotification"
    [theme]="NotificationTheme.SUCCESS"
    [isClosable]="true"
    (closeClick)="showSend2faEmailVerificationCodeSuccessNotification = false"
    class="mr-xsmall-t"
    data-testid="loyalty-email-change-verification-mfa-form-resend-success-notification"
  >
    {{ 'plus.profile.twoFactorAuth.email.verificationStep.resendSuccess' | finLocalization }}
  </fcom-notification>

  <fcom-notification
    *ngIf="resendEmailCount >= 2"
    class="mr-xsmall-t"
    [theme]="NotificationTheme.WARNING"
    data-testid="loyalty-email-change-verification-mfa-form-still-no-code-received-notification"
  >
    {{ 'plus.profile.twoFactorAuth.email.verificationStep.stillNoCodeReceived' | finLocalization }}
  </fcom-notification>

  <ng-container
    *ngIf="authError === AuthError.ValidateCode"
    [ngTemplateOutlet]="notification"
    [ngTemplateOutletContext]="{ text: 'plus.profile.twoFactorAuthFailed' | finLocalization }"
  />
  <ng-container
    *ngIf="authError === AuthError.IncorrectCode"
    [ngTemplateOutlet]="notification"
    [ngTemplateOutletContext]="{
      text: 'plus.profile.twoFactorAuth.email.verificationStep.verifyError' | finLocalization,
    }"
  />

  <ng-container
    *ngIf="authError === AuthError.Resend2faEmail"
    [ngTemplateOutlet]="notification"
    [ngTemplateOutletContext]="{
      text: 'plus.profile.twoFactorAuth.email.verificationStep.resendError' | finLocalization,
    }"
  />
</ng-container>

<ng-template #notification let-text="text">
  <fcom-notification
    aria-live="polite"
    class="mr-xsmall-t"
    [theme]="NotificationTheme.ALERT"
    [layout]="NotificationLayout.BLOCK"
    [isClosable]="true"
    [i18n]="{ closeAriaLabel: 'plus.profile.closeNotification' }"
    (closeClick)="onCloseError()"
  >
    {{ text }}
  </fcom-notification>
</ng-template>
